import { g as getRoomType } from './get-room-type.js';
import './index2.js';

/**
 * Websline
 */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    const roomDetailsParseData = () => {
        const roomsArray = Array.from(document.querySelectorAll('.abm-room'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.abm-headline')?.textContent?.trim() ?? '';
            const roomType = getRoomType(roomName);
            const parentElements = room?.parentElement?.querySelectorAll('.abm-roompackage-list') ?? [];
            const ratesInfo = Array.from(parentElements).map((rate) => {
                const rateName = rate.querySelector('.abm-div-clickable>ul>li')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.abm-price')?.textContent?.trim());
                const hasBreakfast = !!rateName?.match(/breakfast|frühstück/i);
                const isRefundable = false;
                if (!rateName || !ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                type: roomType,
                adults: thn.parseNumber(thn.parseUrlParameter('adults')) ?? 2,
                children: thn.parseNumber(thn.parseUrlParameter('childs')) ?? 0,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        isUserLogged() {
            const isLogged = false;
            return isLogged;
        },
        boot() {
            const container = document.querySelector('#abm-booking');
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                }, 600);
                thn.observeDom(container, refreshPage, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('.abm-requestroom');
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    ctx.widget.refresh().catch(() => { });
                }, 600);
                thn.observeDom(container, refreshPrice, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.host.includes('booking');
            // https://booking.hotel-lenz.at/websLINE-ABM/homepage/booking/Preset/?Arrival=2025-08-01&Departure=2025-08-05
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            // Replace /index/ with /Preset/
            if (url.pathname.includes('/index/')) {
                url.pathname = url.pathname.replace(/\/index\//, '/Preset/');
            }
            url.searchParams.set('Arrival', '[date_begin]');
            url.searchParams.set('Departure', '[date_end]');
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            ctx.newUrl = url.toString();
            return ctx;
        },
        priceParseData() {
            // Guests, Adults & Children
            const adults = thn.parseNumber(document.querySelector('.abm-requestroom-adults')?.value) ?? 2;
            const children = thn.parseNumber(document.querySelector('.abm-requestroom-children')?.value) ?? 0;
            const childrenAges = Array.from(document.querySelectorAll('.abm-requestroom-children-age'))
                .map((el) => thn.parseNumber(el.value)).filter((value) => value !== null);
            // Dates
            const dates = document.querySelector('.abm-header-value')?.textContent?.match(/\d+\.\d+\.\d+/g) ?? [];
            const nights = thn.parseNumber(document.querySelector('.abm-header-info')?.textContent) ?? 1;
            let dateBegin;
            let dateEnd;
            if (dates.length >= 2) { // Text like  Mi. 26.12.2018 - Do. 03.01.2019   8 nights
                dateBegin = dates[0]?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                dateEnd = dates[1]?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
            }
            else if (dates.length === 1) { // Text like  Do. 24. - So. 27.01.2019   3 nights
                dateEnd = dates[0]?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
                dateBegin = thn.dateToString(thn.addDays(dateEnd, -nights));
            }
            if (!dateBegin || !dateEnd) {
                return null;
            }
            // Prices & Currency || No Rooms
            const priceData = Array.from(document.querySelectorAll('.abm-price'))
                .map((priceEl) => {
                const price = thn.parseNumber(priceEl?.textContent);
                const currency = thn.parseCurrency(priceEl?.textContent);
                return price && currency ? { price, currency } : null;
            }).filter((value) => value !== null)
                .sort((a, b) => a.price - b.price);
            const noAvailability = thn.isVisible(document.querySelector('.abm-view-requestroompossibilities .alert-danger:not(#roomFilterErrorDiv)'));
            if (!thn.empty(priceData)) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [{ adults, children, childrenAges }],
                    roomDetails: roomDetailsParseData(),
                    price: priceData[0].price / nights,
                    currency: priceData[0].currency,
                };
            }
            if (thn.empty(priceData) && noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [{ adults, children, childrenAges }],
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingId = thn.dataLayerHelper.get('transactionId');
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            const price = thn.parseNumber(thn.dataLayerHelper.get('transactionTotal'));
            const currency = 'EUR'; // Only EUR is supported
            return {
                bookingId,
                price,
                currency,
            };
        },
    };
};

export { factory };
